<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
<!--                <base-input v-model="username" alternative-->
<!--                            class="mb-3"-->
<!--                            v-mask="'#######-#'"-->
<!--                            placeholder="Número de inscrição"-->
<!--                            addon-left-icon="ni ni-single-02">-->
<!--                </base-input>-->
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '1234567-8',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX1/AWiq5rHRJyizYGtubxMLi88VYrGVevNQ=","cpf":"U2FsdGVkX18z3AJi6rfWq9OdIn+4s6yGYayISSKIuuE="},{"num_cand":"U2FsdGVkX1+8rNrKWPD5Stv/1BM/uZXse9yLfdX2eto=","cpf":"U2FsdGVkX187LytuahlRrEuPv89skS8CznpZ8/KFk2s="},{"num_cand":"U2FsdGVkX1+8x0Xuc9ZVIHmgius3mKlJ4RAgC+C2+Uc=","cpf":"U2FsdGVkX1+8lSYIFD7p01C+u0JTE8gnLNmO9FSTlz0="},{"num_cand":"U2FsdGVkX1+jXL1HB8f0tGSMz/2QFJOipO95ecakEs4=","cpf":"U2FsdGVkX19zAb3i6Cd5GnlnShklr8UY2jUajLwrn2o="},{"num_cand":"U2FsdGVkX1/6/sR1AFfGLTELVAc4CdlH/P796K4VNJ4=","cpf":"U2FsdGVkX19tRU7E10iCD5q1wFNNy63ACEx4UwS8zGI="},{"num_cand":"U2FsdGVkX1/guCQbPdTJqn4BGczm/Z/5Pv1nXg7YPQM=","cpf":"U2FsdGVkX1/70JbAFB0qEpkW8xz9QQ6tOCE16lhMhJY="},{"num_cand":"U2FsdGVkX198JfANc1kX6jI3EK21meXDCiqsnSP8h+E=","cpf":"U2FsdGVkX193dNWcUwJEM/aI/yPO0jxOj5SpCnqP75w="},{"num_cand":"U2FsdGVkX19Ax0F/aRZ3kOIMUK79mTMFCWco12NSmHk=","cpf":"U2FsdGVkX1/r1IYGkydXWdLV+7/b1bETrLfWwmQWXiw="},{"num_cand":"U2FsdGVkX1/k0LtoWPbNTNjrzV4UmbTh6W/GrmFDBt0=","cpf":"U2FsdGVkX1+6fKvVTCr8aMTgwXsrdMd3frJ5TJiArGE="},{"num_cand":"U2FsdGVkX18/Bok2LAmwJr+TGb0icqqF0tzD3XQszEU=","cpf":"U2FsdGVkX1/zdP1ljRZbByEVnB4SdDxE6FH5yMFRqSQ="},{"num_cand":"U2FsdGVkX1+p5bT0I64wwEE4J2YAP/xU7Pe8nwxLhIA=","cpf":"U2FsdGVkX183Joqesvo0JNACKaz1wncqGSLepAuFRgs="},{"num_cand":"U2FsdGVkX180sSv6HXJPkQZb/rMMMIsZyMJENbY+Huw=","cpf":"U2FsdGVkX1+PrGPz97gtws1HSAAYrpfjttK/sCohC2U="},{"num_cand":"U2FsdGVkX199uZWZPGTQymqfpLYW6kO6dgj0afBJhRc=","cpf":"U2FsdGVkX199/BqbS3V6M8Rno0kcQRB6PF1Ez8abc7E="},{"num_cand":"U2FsdGVkX1+cc3h501DtgAZ/ZIWf6Ya1vouunBoNhHI=","cpf":"U2FsdGVkX1/ubKNyVBo656iiSc9VjJCVDRWynRXnuuI="},{"num_cand":"U2FsdGVkX18eGoyJglz007Saw4ITgpCBeGbosrgRYSw=","cpf":"U2FsdGVkX1/hcUsrVAWaUmACxdyN5pFHDbcmW218Ewk="},{"num_cand":"U2FsdGVkX1/kaHy1XaZf+vKGjvAK5lzGdrfKaSxfxYM=","cpf":"U2FsdGVkX18Rjc5Yae/EEscv+z3G+1Sw/+A+ijIrLNw="},{"num_cand":"U2FsdGVkX1+/Zq4uoMlEw7NgsuTE0eXRHcL9V5i8CeA=","cpf":"U2FsdGVkX1/Itm3dzUNebMeOYd9wIQZPTaztBSrV1FY="},{"num_cand":"U2FsdGVkX18eQCCg7kHH4jS4w/V6D4DoSnzt7lO4JLg=","cpf":"U2FsdGVkX1/JKTxrbWPU9YEp3WM+XXtoss2CWXo6JkA="},{"num_cand":"U2FsdGVkX195gZUEqU16DUQZH+cvSCBxcMip7PnZPio=","cpf":"U2FsdGVkX18391BEstQpMmghkfY5WfPGPrwRaz8GCuc="},{"num_cand":"U2FsdGVkX19WeILOY4QdlDeHVKk1UMOl8jZQjks48pY=","cpf":"U2FsdGVkX18KhvCSXLVLNggau4lWf0AOENxNzT7XyB0="},{"num_cand":"U2FsdGVkX1/fM5W2/mb63gwhcPAraKF2HNAU8ktVKNY=","cpf":"U2FsdGVkX1/yDgSijLntGlEN2+jX7HzMn0RmA7lyW7Q="},{"num_cand":"U2FsdGVkX1+gMvzhmzogOzBMZv8SKwUy+5ZT1i2EpkU=","cpf":"U2FsdGVkX1/N6zqdsSZay50BHWflPfIuJu4f84/YCIE="},{"num_cand":"U2FsdGVkX1/6tQ2JYDRDpKJzDq0atFA/M7PUjmIz/18=","cpf":"U2FsdGVkX18woc0IbyBx+ogwA/jsM1yn++DS140oR50="},{"num_cand":"U2FsdGVkX19u4QZ6aldqXs7qrCp5l5YI/BITcKif3bQ=","cpf":"U2FsdGVkX19EeY/ootXaECgz6S/4EDrxclG1x4zbxgY="},{"num_cand":"U2FsdGVkX19H0tmtLXCRiAr4ZS8l4RqVD11mBzXaULg=","cpf":"U2FsdGVkX18mUFsGAtP1WZjN+/VWjhbf3Ylgm/6XL7w="},{"num_cand":"U2FsdGVkX1/8RwT1JfKQHd+NfIpsGGqSKJTAlr9BYcY=","cpf":"U2FsdGVkX19eCDc52yL5FaB3SdAjhA/5d/kr95IP8Eo="},{"num_cand":"U2FsdGVkX18Q2mMnvswK7MsPPsEBkVkqGqIXSoK7PZw=","cpf":"U2FsdGVkX182Hri/KyDvo5/3bEtGXfNkKTArXPwhnts="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))
              nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2218/impuganacao/${nome_arquivo}`)
              return window.location = url;          }


        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
